module.exports = __webpack_public_path__ + "static/media/yellowsmall.5484fb4a.svg";